// Formats an ISO timestamp as an absolute, locale-friendly date, e.g. "June 5, 2026".
export const formatAbsoluteDate = (iso) => {
    return new Date(iso).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
}

const DIVISIONS = [
    { amount: 60, unit: 'seconds' },
    { amount: 60, unit: 'minutes' },
    { amount: 24, unit: 'hours' },
    { amount: 7, unit: 'days' },
    { amount: 4.34524, unit: 'weeks' },
    { amount: 12, unit: 'months' },
    { amount: Number.POSITIVE_INFINITY, unit: 'years' },
]

// Formats an ISO timestamp relative to `now`, e.g. "6 days ago".
export const formatRelativeDate = (iso, now = new Date()) => {
    const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
    let duration = (new Date(iso).getTime() - now.getTime()) / 1000
    for (const division of DIVISIONS) {
        if (Math.abs(duration) < division.amount) {
            return rtf.format(Math.round(duration), division.unit)
        }
        duration /= division.amount
    }
    return ''
}

// Combined display, e.g. "June 5, 2026 (6 days ago)". Returns null when there is no value.
// NOTE: both formats are shown intentionally (issue #269) so the team can choose one later;
// dropping to a single format is a one-line change here.
export const formatLastUpdated = (iso, now = new Date()) => {
    if (!iso) return null
    return `${formatAbsoluteDate(iso)} (${formatRelativeDate(iso, now)})`
}
